import React from "react";

export function fmtDate(iso) {
  if (!iso) return "never via UI (still the .env seed)";
  const d = new Date(iso);
  return isNaN(d) ? iso : d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
}

export function PwInput({ id, label, value, onChange, show, autoComplete }) {
  return (
    <div>
      <label htmlFor={id} className="label-tiny block mb-1.5">{label}</label>
      <input
        id={id}
        data-testid={id}
        type={show ? "text" : "password"}
        autoComplete={autoComplete}
        required
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="admin-input w-full bg-transparent border border-zinc-800 rounded-sm px-3 py-2 text-sm text-zinc-100 focus:border-zinc-500"
        placeholder="•••••••••••"
      />
    </div>
  );
}

export function SignedInRow({ user }) {
  return (
    <div className="px-5 py-3 grid grid-cols-1 md:grid-cols-[260px_1fr] gap-3 items-center">
      <div className="text-sm text-zinc-300">Signed in as</div>
      <div className="text-sm">
        <span data-testid="security-account-email" className="mono text-zinc-100">{user?.email || "…"}</span>
        <div data-testid="security-password-changed-at" className="text-[11px] text-zinc-500 mono mt-0.5">
          password last changed: {fmtDate(user?.password_changed_at)}
        </div>
      </div>
    </div>
  );
}
